import { useNavigate } from "react-router-dom";
import { MessageSquareText, Smile, HeartHandshake, ArrowRight } from "lucide-react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

const SECTIONS = [
  { icon: MessageSquareText, title: "Slang & trend decoder", body: "Type a word or phrase — 'delulu', 'no cap', 'looksmaxxing' — and get a plain-English meaning, why kids use it, the feeling behind it, and a warm reply you can actually say.", example: "“He said his room is 'mid'. Is that bad?”" },
  { icon: Smile, title: "Emoji & meme decoder", body: "Emojis carry hidden meanings that shift fast. We decode single emojis, combinations and popular memes so a 💀 or 🫠 never leaves you guessing.", example: "“What does 🧢 mean when she texts it?”" },
  { icon: HeartHandshake, title: "Mood & behaviour explainer", body: "Describe a change you've noticed — quieter, more secretive, glued to a game. We offer calm, non-clinical context and gentle next steps. Never a diagnosis.", example: "“She's been really withdrawn after school.”" },
];

export default function Features() {
  const nav = useNavigate();
  return (
    <div>
      <PublicNav />
      <section className="dk-container py-16">
        <div className="max-w-2xl mb-12">
          <span className="badge-soft mb-3">Features</span>
          <h1 className="text-[32px] sm:text-[40px] font-semibold">Everything you need to speak their language</h1>
          <p className="mt-3 text-[18px]" style={{ color: "var(--text-muted)" }}>Personalised to each child through private profiles that store only an age band, an optional nickname and a style tag.</p>
        </div>
        <div className="space-y-6">
          {SECTIONS.map((s, i) => (
            <div key={s.title} className={`dk-card p-8 grid md:grid-cols-2 gap-8 items-center ${i % 2 ? "md:[direction:rtl]" : ""}`}>
              <div className="md:[direction:ltr] space-y-4">
                <span className="grid place-items-center w-12 h-12 rounded-xl" style={{ background: "var(--sage-tint)" }}><s.icon style={{ color: "var(--sage)" }} /></span>
                <h2 className="font-serif text-[24px] font-medium">{s.title}</h2>
                <p style={{ color: "var(--text-muted)" }}>{s.body}</p>
              </div>
              <div className="md:[direction:ltr] rounded-xl p-6" style={{ background: "var(--card-alt)" }}>
                <p className="text-xs uppercase tracking-wide mb-2" style={{ color: "var(--text-muted)" }}>A parent asked…</p>
                <p className="font-serif text-[20px]">{s.example}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <button className="btn btn-primary mx-auto" onClick={() => nav("/auth/signup")}>Try every tool free <ArrowRight size={16} /></button>
        </div>
      </section>
      <Footer />
    </div>
  );
}
